<template>
    <div>
        <div class="calendar-grid">
            <div v-for="(day, index) in calendarGrid" :key="index" class="calendar-card" :class="{
                'none-show': day.day == null,
                'out-year': !day.isCurrentYear,
                'current-month': day.isCurrentMonth,
                'editable': day.isEditable && day.isCurrentMonth,
                'blocked': !day.isEditable && day.isCurrentMonth,
            }">
                <div class="day-box">{{ day.day }}</div>
                <section class="dayValueContainer">
                    <span>Valor Absoluto</span>
                    <section @click="editValue(day)">
                        <input v-show="day.editing" type="number" v-model="day.value" @blur="saveValue(day)"
                            @keyup.enter="saveValue(day)" autofocus />
                        <label v-show="!day.editing">{{ day.value }}</label>
                        <span v-show="!day.editing" class="measurement">{{ localCalendar.Measurement }}</span>
                    </section>

                </section>
            </div>
        </div>
        <div class="calendar-footer">
            <section @click="changeName(true)">
                <b-form-input v-show="editName == true" type="text" v-model="localCalendarName" autofocus
                    @keyup.enter="changeName(false)" @blur="changeName(false)"/>
                <span v-show="editName == false" @click="changeName(true)">{{ localCalendarName }}</span>
            </section>

            <section class="month-navigation">

                <button @click="previousMonth">
                    <b-icon-arrow-left-circle-fill />
                </button>
                <span>{{ currentMonthName }} de {{ year }}</span>
                <button @click="nextMonth">
                    <b-icon-arrow-right-circle-fill />
                </button>
            </section>
            <span class="accVal">Acumulado: {{ monthAcc.toFixed(2).toString().replace(".", ",") }} {{
                localCalendar.Measurement }}</span>
        </div>
    </div>
</template>

<script>
import SeasonalCalendarRepository from '../service/SeasonalCalendarRepository';

export default {
    props: ["calendarData", "calendarName"],
    data() {
        return {
            currentMonthIndex: 0,
            year: this.calendarData.Year,
            localCalendar: {
                Year: this.calendarData.Year,
                Measurement: "",
                Months: []
            },
            monthAcc: 0,
            editName: false,
            localCalendarName: this.calendarName,
        };
    },
    computed: {
        currentMonthData() {
            if (this.localCalendar.Months && this.localCalendar.Months.length > 0 && this.currentMonthIndex < this.localCalendar.Months.length) {
                return this.localCalendar.Months[this.currentMonthIndex];
            }
            return { SeasonalDays: [] };
        },
        currentMonthName() {
            return this.currentMonthData.MonthName || '';
        },
        calendarGrid() {
            return this.getCalendarGrid(this.currentMonthData);
        },
    },
    watch: {
        calendarData: {
            immediate: true,
            handler(newVal) {
                this.localCalendar = newVal;
                this.localCalendarName = this.calendarName;
                this.currentMonthIndex = this.getMonthIndex();
            },
        },
    },
    methods: {
        changeName(status) {
            if (this.localCalendarName.includes("Acumulado - ")) return;
            if (status == false) {
                this.$emit('updateCalendarName', this.localCalendarName);
            }
            this.editName = status
            this.$forceUpdate();
        },

        editValue(day) {
            this.calendarGrid.forEach(d => {
                d.editing = false;
            });

            if (day.isEditable == true && day.isCurrentMonth == true) {
                day.editing = true;
            }
            this.$forceUpdate();
        },
        saveValue(day) {
            if (day.value == '') day.value = 0
            day.editing = false;

            this.localCalendar.Months[this.currentMonthIndex].SeasonalDays.forEach(item => {
                if (item.DateTime == day.originalDate) item.DateValue = day.value
            })

            this.$forceUpdate();
        },
        nextMonth() {
            if (this.currentMonthIndex < this.localCalendar.Months.length - 1) {
                this.currentMonthIndex++;
            } else {
                this.currentMonthIndex = 0;
            }
        },
        previousMonth() {
            if (this.currentMonthIndex > 0) {
                this.currentMonthIndex--;
            } else {
                this.currentMonthIndex = this.localCalendar.Months.length - 1;
            }
        },

        getCalendarGrid(monthData) {
            this.editName = false;
            SeasonalCalendarRepository.fullLoading = true;

            this.monthAcc = 0;
            const parseDate = (dateString) => {
                const [year, month, day] = dateString.split('-');
                return new Date(year, month - 1, day);
            };

            if (!monthData.SeasonalDays || monthData.SeasonalDays.length === 0) return [];

            const firstDayOfMonth = parseDate(monthData.SeasonalDays[0].DateTime);
            const startOfGrid = new Date(firstDayOfMonth);
            startOfGrid.setDate(firstDayOfMonth.getDate() - firstDayOfMonth.getDay());

            const gridDays = 42;
            let currentDay = new Date(startOfGrid);
            const grid = [];
            let today = new Date().setDate(new Date().getDate() - 1);

            for (let i = 0; i < gridDays; i++) {
                const dayString = currentDay.toISOString().split('T')[0];
                const seasonalDay = monthData.SeasonalDays.find(
                    (day) => parseDate(day.DateTime).toISOString().split('T')[0] === dayString
                );
                const weekIndex = Math.floor(i / 7);
                const weekClass = weekIndex % 2 === 0 ? 'week-even' : 'week-odd';
                grid.push({
                    day: currentDay.getDate(),
                    date: dayString,
                    originalDate: seasonalDay ? seasonalDay.DateTime : "",
                    dayOfWeek: currentDay.getDay(),
                    value: seasonalDay ? seasonalDay.DateValue : "0",
                    isCurrentMonth: seasonalDay != null,
                    isCurrentYear: currentDay.getFullYear() == this.year,
                    isEditable: currentDay >= today && !this.calendarName.includes("Acumulado - "),
                    weekClass,
                    editing: false,
                });

                if (seasonalDay) {
                    let val = SeasonalCalendarRepository.FormatNumber(seasonalDay.DateValue)
                    this.monthAcc += val != null ? val : 0;
                }

                currentDay.setDate(currentDay.getDate() + 1);
            }

            if (monthData.MonthName.toLowerCase() === "janeiro") {
                const weekDate = firstDayOfMonth.getDay();
                for (let i = 0; i < weekDate; i++) {
                    grid.unshift({
                        day: null,
                        date: null,
                        dayOfWeek: null,
                        value: null,
                        isCurrentMonth: null,
                        isEditable: null,
                        editing: null,
                    });
                }
            }

            else if (monthData.MonthName.toLowerCase() === "dezembro") {
                const lastDayOfMonth = parseDate(monthData.SeasonalDays[monthData.SeasonalDays.length - 1].DateTime);
                const lastDayOfWeek = lastDayOfMonth.getDay();
                for (let i = lastDayOfWeek + 1; i <= 6; i++) {
                    grid.push({
                        day: null,
                        date: null,
                        dayOfWeek: null,
                        value: null,
                        isCurrentMonth: null,
                        isEditable: null,
                        editing: null,
                    });
                }
            }
            SeasonalCalendarRepository.fullLoading = false;
            return grid;
        },


        getMonthIndex() {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth();

            const monthIndex = this.localCalendar.Months.findIndex(
                (month) => month.MonthName.toLowerCase() === this.localCalendar.Months[currentMonth].MonthName.toLowerCase()
            );
            return monthIndex !== -1 ? monthIndex : 0
        }
    },
    mounted() {
        this.localCalendar = this.calendarData;
        this.localCalendarName = this.calendarName;
        this.currentMonthIndex = this.getMonthIndex()
    },

};
</script>

<style scoped>
.calendar-footer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    padding: 0.5rem;
}

.calendar-footer span {
    font-size: 1rem;
    font-weight: bold;
    align-self: center;
}

.calendar-footer .accVal {
    justify-self: flex-end;
}

.month-navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    column-gap: 1rem;
}

.month-navigation button {
    cursor: pointer;
    background-color: transparent;
    border: none;
}

.month-navigation svg {
    font-size: 1.8rem;
}

.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(6, 4rem);
    padding: 0.1rem;
}

.calendar-card {
    border: 1px solid #07838b;
    border-radius: 0.2rem;
    height: 100%;
    width: 100%;
    background-color: #0ab4c0;
    text-align: center;
    user-select: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-shadow: 0 0 2px #0008;
    column-gap: 0.5rem;
    padding: 0.2rem;
}

.calendar-card .day-box {
    padding: 0;
    width: 30px;
    font-weight: 700;
    border: 2px solid #ffe;
    border-radius: 3px;
    text-align: center;
    color: #ffe;
    text-shadow: 0 0 2px #5555;
    font-size: 0.8rem;
    align-self: flex-start;
}

.calendar-card .dayValueContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.calendar-card .dayValueContainer input {
    width: 60px;
    height: 20px;
}

.calendar-card .dayValueContainer span {
    font-size: 0.7rem;
    font-weight: 400;
    color: #525252;
}

.calendar-card:hover {
    filter: brightness(95%) !important;
}

.calendar-card.current-month {
    background-color: #fff8dc;
    font-weight: bold;
}

.out-year {
    filter: opacity(0);
}

.none-show {
    display: none;
}

.editable {
    background-color: #89d8e0 !important;
}

.blocked {
    background-color: #9abcc0 !important;
    font-weight: 700 !important;
}

.measurement {
    color: #000 !important;
    font-weight: 600 !important;
    font-size: 0.7rem;
    margin-left: 1px;
}

label {
    font-weight: 700 !important;
}

.editedNotSaved {
    color: #ff8827 !important;
}

@media (min-width:1800px) {
    .calendar-grid {
        grid-template-rows: repeat(6, 5.4rem);
    }

    .calendar-card .dayValueContainer input {
        width: 100px;
        height: 30px;
        font-size: 1rem;
    }

    .calendar-card .dayValueContainer span {
        font-size: 0.9rem;
        font-weight: 400;
        color: #525252;
    }

    .measurement {
        color: #000 !important;
        font-weight: 600 !important;
        font-size: 0.7rem;
        margin-left: 1px;
    }

    label {
        font-size: 1.3rem;
    }

    .calendar-card .day-box {
        width: 50px;
    }
}
</style>
